import React, { useState } from "react";
import { cn } from "@/lib/utils";

export type AvatarTone = "blue" | "green" | "amber" | "stone";

const TONE_CLASSES: Record<AvatarTone, string> = {
  blue:  "bg-waves-lucht text-waves-ink",
  green: "bg-status-ok-bg text-status-ok-fg",
  amber: "bg-status-warn-bg text-status-warn-fg",
  stone: "bg-status-neutral-bg text-waves-ink",
};

export function UserAvatar({
  name,
  pictureUrl,
  size = 28,
  tone = "blue",
  className,
}: {
  name: string;
  pictureUrl?: string | null;
  size?: number;
  tone?: AvatarTone;
  className?: string;
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const initials = (name || "??").split(" ").map(w => w[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();

  if (pictureUrl && !imageFailed) {
    return (
      <img
        src={pictureUrl}
        alt={name}
        onError={() => setImageFailed(true)}
        className={cn("inline-block rounded-full object-cover shrink-0 border-2 border-white", className)}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-full font-mono font-semibold shrink-0 border-2 border-white",
        TONE_CLASSES[tone] ?? TONE_CLASSES.blue,
        className
      )}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}
    >
      {initials}
    </span>
  );
}
